import React, { useEffect, useState } from 'react';
import styles from 'styles/Course.module.scss';
import classnames from 'classnames';
import { getThemeColor, getColor } from 'store/settings';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { Carousel } from 'react-responsive-carousel';
import ImageLoader from '../../../components/Image';
import { DEFAULT_IMAGE, USER_ROLES } from 'constants/constants';
import { Progress } from 'reactstrap';
import { useRouter } from 'next/router';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import Swal from 'sweetalert2';
import { setDetailPageCurrentTab, setYetToStart } from 'store/global';
import { getSelectedCentre } from 'store/master';
import { handleToastError } from 'helpers';
import reportApi from 'api/reportApi';
const ClassCarosel = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const selectedCentre = useSelector(getSelectedCentre);
  const themeStatus = useSelector(getThemeColor);
  const colorStatus = useSelector(getColor);
  const [intakeInProgress, setIntakeInProgress] = useState();
  const Stylescal = styled.div`
    .carousel .control-prev.control-arrow:before {
      border-right: 8px solid ${themeStatus} !important;
      margin-left: -4px !important;
    }
    .carousel .control-next.control-arrow:before {
      border-left: 8px solid ${themeStatus} !important;
    }
    .card-body {
      padding: 10px;
      padding-top: 20px;
    }
  `;
  async function WatchContinue() {
    try {
      let params = { role: USER_ROLES.LEARNER };
      if (selectedCentre?._id) {
        params.courseCentre = selectedCentre?._id;
      }
      const response = await reportApi.getWatchContinue(params);
      setIntakeInProgress(response?.data);
    } catch (error) {
      handleToastError(error);
    }
  }
  useEffect(() => {
    WatchContinue();
  }, [selectedCentre]);

  const redirectToContent = async (item) => {
    let days = parseInt(item?.differenceDays);
    if (days > 3) {
      await Swal.fire({
        position: 'center',
        paddingTop: '50px',
        title: 'Intakes',
        imageUrl: 'images/danger.png',
        imageWidth: 55,
        imageHeight: 55,
        fontSize: 18,
        confirmButtonColor: colorStatus,
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        text: `You can access this intake only before three days from the start date`,
      });
    } else {
      await router.push(`/course/${item?._id}`);
    }
    dispatch(setDetailPageCurrentTab([]));
    dispatch(setYetToStart([]));
  };

  return (
    <>
      <div>
        {intakeInProgress?.length > 0 ? (
          <div>
            <h6 className="heading_text_title">Classes in Progress</h6>
            <Stylescal>
              <Carousel
                autoPlay={true}
                infiniteLoop={false}
                showIndicators={false}
                showArrows={true}
                showThumbs={false}
                indicators={false}
                nextIcon=""
                nextLabel=""
              >
                {intakeInProgress?.map((data) => (
                  <div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div
                          className={classnames(
                            'cursor-pointer',
                            'shadow',
                            styles['bordershade-learner'],
                          )}
                          onClick={() => redirectToContent(data)}
                        >
                          <div className="upload-carousel-image-new">
                            <ImageLoader
                              src={data?.thumbnail?.root || DEFAULT_IMAGE}
                              width=""
                              objectFit="fill"
                              height="130"
                            />
                          </div>
                          <div className="card-body">
                            <p className="text-left mb-0 pb-0 view-page-name">
                              {data?.category?.name}
                            </p>
                            <a onClick={() => redirectToContent(data)}>
                              <p
                                className={classnames(
                                  'text-left',
                                  'ellipsis-learner',
                                  'Carosel-label',
                                  styles['ellipsis-learner'],
                                  styles['Carosel-label'],
                                )}
                              >
                                {data?.name}
                              </p>
                            </a>
                            <a onClick={() => redirectToContent(data)}>
                              <h4
                                className={classnames(
                                  'tooltip',
                                  styles['tooltip'],
                                )}
                              >
                                {data?.name}
                              </h4>
                            </a>

                            <Progress
                              className={classnames(
                                'progress',
                                'c-progress',
                                styles['c-progress'],
                              )}
                              color="success"
                              value={data?.progress}
                            >
                              {data?.progress}%
                            </Progress>

                            <div className={classnames('row', 'my-50')}>
                              <div className="col-6 text-left view-page-name">
                                <i
                                  class="fa fa-folder-o"
                                  aria-hidden="true"
                                ></i>{' '}
                                {data?.totalUnits} Lessons
                              </div>
                              <div className="col-6 text-right view-page-name">
                                {data?.code}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </Stylescal>
          </div>
        ) : (
          <div>
            <h5 className="card-header-title-label">Classes in Progress</h5>
            <div className="row">
              <div className="col-lg-12">
                <div
                  className={classnames(
                    'cursor-pointer',
                    styles['bordershade-learner'],
                  )}
                  onClick={() => redirectToContent()}
                >
                  <div className="upload-carousel-image-new">
                    <ImageLoader
                      src={DEFAULT_IMAGE}
                      className={classnames('course-img', styles['course-img'])}
                      width=""
                      objectFit="fill"
                      height="130"
                    />
                  </div>
                  <div className="card-body py-0">
                    <div className=" row">
                      <div className="col">
                        <h5 className="my-50 heading_text_title text-center">
                          No Class In Progress
                        </h5>
                        <p
                          className="view-page-name text-center"
                          style={{ marginBottom: '2rem' }}
                        >
                          Currently you have no classes in progress
                        </p>

                        <Progress
                          className={classnames(
                            'progress',
                            'c-progress',
                            'mb-1',
                            styles['c-progress'],
                          )}
                          color="success"
                          value={0}
                        >
                          0%
                        </Progress>

                        <div className="col-6 view-page-name">
                          <p className="my-1">
                            <i class="fa fa-folder-o" aria-hidden="true"></i> 0
                            Lessons
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ClassCarosel;
